import { render } from "./SlidePage.vue?vue&type=template&id=41fa4241&scoped=true"
import script from "./SlidePage.vue?vue&type=script&lang=js"
export * from "./SlidePage.vue?vue&type=script&lang=js"

import "./SlidePage.vue?vue&type=style&index=0&id=41fa4241&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41fa4241"]])

export default __exports__